import {
  DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK,
  DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK,
  DASHBOARD_LOGOUT_INIT,
  DASHBOARD_LOGOUT_SUCCESS,
  DASHBOARD_LOGOUT_FAILURE,
  DASHBOARD_GET_USER_PROFILE_INIT,
  DASHBOARD_GET_USER_PROFILE_SUCCESS,
  DASHBOARD_GET_USER_PROFILE_FAILURE,
  DASHBOARD_SET_ACTIVE_MAIN_MENU,  
  DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION,
  DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION,
  DASHBOARD_SAVE_ACTUAL_USER_INIT,
  DASHBOARD_SAVE_ACTUAL_USER_SUCCESS,
  DASHBOARD_SAVE_ACTUAL_USER_FAILURE,
  DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY,
  DASHBOARD_SAVE_ACTUAL_USER_RESET,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS,
  DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE,
  DASHBOARD_GET_NOTIFICATIONS_INIT,
  DASHBOARD_GET_NOTIFICATIONS_SUCCESS,
  DASHBOARD_GET_NOTIFICATIONS_FAILURE,
  DASHBOARD_GET_NOTIFICATION_INIT,
  DASHBOARD_GET_NOTIFICATION_SUCCESS,
  DASHBOARD_GET_NOTIFICATION_FAILURE,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS,
  DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE,
  DASHBOARD_DELETE_NOTIFICATION_DATA_INIT,
	DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS,
	DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE,
  DASHBOARD_GET_CUSTOMER_INIT,
  DASHBOARD_GET_CUSTOMER_SUCCESS,
  DASHBOARD_GET_CUSTOMER_FAILURE,
  DASHBOARD_UPDATE_CUSTOMER_INIT,
  DASHBOARD_UPDATE_CUSTOMER_SUCCESS,
  DASHBOARD_UPDATE_CUSTOMER_FAILURE,
  DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY,
  DASHBOARD_UPDATE_CUSTOMER_RESET,
  DASHBOARD_STOP_PROCESS_INIT,
  DASHBOARD_STOP_PROCESS_SUCCESS,
  DASHBOARD_STOP_PROCESS_FAILURE,
  DASHBOARD_GET_PERIODS_LIST_INIT,
  DASHBOARD_GET_PERIODS_LIST_SUCCESS,
  DASHBOARD_GET_PERIODS_LIST_FAILURE,
  DASHBOARD_SET_FIXED_PERIOD_ID,
  DASHBOARD_RESET,
  DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE,
  DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS,
  DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE,
  DASHBOARD_GET_TOURS_STATE_INIT,
  DASHBOARD_GET_TOURS_STATE_SUCCESS,
  DASHBOARD_GET_TOURS_STATE_FAILURE,
  DASHBOARD_SET_TOURS_STATE_INIT,
  DASHBOARD_SET_TOURS_STATE_SUCCESS,
  DASHBOARD_SET_TOURS_STATE_FAILURE,
  DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE,
  DASHBOARD_SAVE_USER_IMAGE_INIT,
  DASHBOARD_SAVE_USER_IMAGE_SUCCESS,
  DASHBOARD_SAVE_USER_IMAGE_FAILURE,
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import Constants from '../../../definitions/constants';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function resetDashboard() {
  return {
    type: DASHBOARD_RESET
  };
}

export function handleMainMenuItemClick(itemKey,itemParent) {
  return {
    type: DASHBOARD_HANDLE_MAIN_MENU_ITEM_CLICK,
    payload: {
      itemKey,
      itemParent
    }
  };
}

export function handleTopMenuItemClick(itemKey) {
  return {
    type: DASHBOARD_HANDLE_TOP_MENU_ITEM_CLICK,
    payload: {
      itemKey
    }
  };
}

export function setActiveMainMenu(route) {
  return {
    type: DASHBOARD_SET_ACTIVE_MAIN_MENU,
    payload: {
      route
    }
  };
}

export function logout() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_LOGOUT_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/logout",
        "DELETE"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_LOGOUT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_LOGOUT_FAILURE, error));
    }  
  };
}

export function getUserProfile() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_GET_USER_PROFILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/userprofile",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_USER_PROFILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_USER_PROFILE_FAILURE, error));
    }  
  };
}

export function setOnScrollBottomAction(action) {
  return {
    type: DASHBOARD_SET_ON_SCROLL_BOTTOM_ACTION,
    payload: {
      action
    }
  };
}

export function unsetOnScrollBottomAction() {
  return {
    type: DASHBOARD_UNSET_ON_SCROLL_BOTTOM_ACTION
  };
}

export function saveActualUser(userData) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_SAVE_ACTUAL_USER_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/user/save",
        "POST",
        null,
        userData
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_SAVE_ACTUAL_USER_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_SAVE_ACTUAL_USER_FAILURE, error));
    }  
  };
}

export function setSaveActualUserDataByKey(key, value) {
  return {
    type: DASHBOARD_SET_SAVE_ACTUAL_USER_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSaveActualUser(data) {
  return {
    type: DASHBOARD_SAVE_ACTUAL_USER_RESET,
    data: data 
  };
}

export function getNotViewedNotificationsCount() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/notviewednotificationscount",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_NOT_VIEWED_NOTIFICATIONS_COUNT_FAILURE, error));
    }  
  };
}

export function getNotifications(page = 1) {
  let params = {
    order_fields: ["created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC],
    per_page: Constants.interface.notificationsPageSize,
    page: page
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: DASHBOARD_GET_NOTIFICATIONS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/notifications",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_NOTIFICATIONS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_NOTIFICATIONS_FAILURE, error));
    }  
  };
}

export function getNotification(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_GET_NOTIFICATION_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getnotification",
        "GET",
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_NOTIFICATION_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_NOTIFICATION_FAILURE, error));
    }  
  };
}

export function downloadNotificationFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/session/downloadnotificationfile",
        params.notificationFileName ? params.notificationFileName :
          intl.formatMessage(
            { id: "notifications.downloadFileName"}, 
            { notificationId: params.notificationId }
          ),
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_DOWNLOAD_NOTIFICATION_FILE_FAILURE, error));
    }  
  };
}

export function deleteNotificationData(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_DELETE_NOTIFICATION_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/deletemetricdatabyjobkey",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_DELETE_NOTIFICATION_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_DELETE_NOTIFICATION_DATA_FAILURE, error));
    }  
  };
}

export function getCustomer() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_GET_CUSTOMER_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getcustomer",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_CUSTOMER_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_CUSTOMER_FAILURE, error));
    }  
  };
}

export function updateCustomer(files, params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_UPDATE_CUSTOMER_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/session/updatecustomer",
        files,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_UPDATE_CUSTOMER_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_UPDATE_CUSTOMER_FAILURE, error));
    }  
  };
}

export function setUpdateCustomerDataByKey(key, value) {
  return {
    type: DASHBOARD_SET_UPDATE_CUSTOMER_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetUpdateCustomer(data) {
  return {
    type: DASHBOARD_UPDATE_CUSTOMER_RESET,
    data: data 
  };
}

export function stopProcess(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_STOP_PROCESS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/stopprocess",
        "PUT",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_STOP_PROCESS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_STOP_PROCESS_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: DASHBOARD_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function setFixedPeriodId(id) {
  return {
    type: DASHBOARD_SET_FIXED_PERIOD_ID,
    id: id
  };
}

export function setHandleNotificationDetailPopupReference(functionParam) {
  return {
    type: DASHBOARD_SET_HANDLE_NOTIFICATION_DETAIL_POPUP_REFERENCE,
    payload: functionParam
  };
}

export function setHandleCheckRouteTourAvailabilityReference(functionParam) {
  return {
    type: DASHBOARD_SET_HANDLE_CHECK_ROUTE_TOUR_AVAILABILITY_REFERENCE,
    payload: functionParam
  };
}

export function setActiveTourFunctionReference(functionParam) {
  return {
    type: DASHBOARD_SET_ACTIVE_TOUR_FUNCTION_REFERENCE,
    payload: functionParam
  };
}

export function setAllNotificationsViewed(){
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/setallnotificationsviewed",
        "PUT"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_SET_ALL_NOTIFICATIONS_VIEWED_FAILURE, error));
    }  
  };
}

export function getToursStates(){
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_GET_TOURS_STATE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/gettoursstates",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_GET_TOURS_STATE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_GET_TOURS_STATE_FAILURE, error));
    }  
  };  
}

export function setToursStates(tourId, tour_state){
  let params = {
    tour_id: tourId,
    tour_state: tour_state,
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_SET_TOURS_STATE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/settourstates",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_SET_TOURS_STATE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_SET_TOURS_STATE_FAILURE, error));
    }  
  };  
}

export function saveUserImage(files, insertImageCallback) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(DASHBOARD_SAVE_USER_IMAGE_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/assets/saveuserimage",
        files
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(DASHBOARD_SAVE_USER_IMAGE_SUCCESS, resp));
      if(resp && resp.status == 200 && resp.data && resp.data.user_image_url) {
        insertImageCallback(resp.data.user_image_url);
      }
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(DASHBOARD_SAVE_USER_IMAGE_FAILURE, error));
    }  
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/dashboard/index.js